// plan_type period
const cloudPlanNameMap = {
  '5_2': 'Plus',
  '5_3': 'Premium',
  '6_3': 'Platinum'
}

const vault_plan = {

}

function getPlanNameFromMap(){

}


export {
  cloudPlanNameMap
}



// WEBPACK FOOTER //
// ./src/utils/planNameMap/index.js